import React, { FC, PropsWithChildren } from "react";
import styled from "@emotion/styled";
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Wrapper = styled.div`
  padding: 6px;
  text-align: center;
  display: flex;
  justify-content: center;
  gap: 10px;
  font-size: 12px;
  align-items: baseline;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: #1e64ddff;
`;

const TosLink: FC<PropsWithChildren<{ to: string }>> = ({ to, children }) => {
  return (
    <StyledLink to={to} target="_blank">
      {children}
    </StyledLink>
  );
}

const Footer: FC = () => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <Typography fontSize="12px">Argoli © {new Date().getFullYear()}</Typography>
      <TosLink to={t("termsOfService.termsUrl")}>{t("termsOfService.termsLink")}</TosLink>
      <TosLink to={t("termsOfService.privacyPolicyUrl")}>{t("termsOfService.privacyPolicyLink")}</TosLink>
    </Wrapper>
  );
};

export default Footer;
